import { render, staticRenderFns } from "./BocIcon.vue?vue&type=template&id=6d1d92f8&scoped=true"
import script from "./BocIcon.vue?vue&type=script&lang=js"
export * from "./BocIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d1d92f8",
  null
  
)

export default component.exports